import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import '../assets/scss/main.scss'

import Header from '../components/header'
import Footer from '../components/footer'

const Layout = ({ children, location }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
        wp {
          siteSettings {
            acf {
              servicesMenu {
                link {
                  title
                  url
                }
              }
            }
          }
        }     
      }
    `}
    render={data => {
      return (
        <>
          <Header servicesMenu={data.wp.siteSettings.acf.servicesMenu} />
          <main>{ children }</main>
          <Footer />
        </>
      )
    }
    }
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
